/**
 * @name Eglise EMIA
 * @author Mr. Josia Yvan
 * @description System API and Management System Software ~ Developed By Mr. Josia Yvan
 * @copyright ©2025 ― Mr. Josia Yvan. All rights reserved.
 * @version v0.0.1
 *
 */
import { FireOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

function Public() {
  window.document.title = 'Eglise EMIA';

  return (
    <div className='h-screen flex flex-col items-center justify-center'>
      <Result
        title={(
          <h2 className='text-lg font-text-font font-medium md:text-3xl'>
            Bienvenue sur le site de l&apos;Eglise EMIA
          </h2>
        )}
        icon={<FireOutlined />}
        extra={(
          <Link to='/admin-home'>
            <Button
              type='primary'
              shape='round'
              size='large'
            >
              Go to Admin panel
            </Button>
          </Link>
        )}
      />
    </div>
  );
}

export default Public;
